<template>
  <div
    class="modal fade modal-org-single"
    id="modal-archivo-org-pdf"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div
      class="
        modal-dialog modal-xl modal-dialog-centered
        modal-org-single__dialog
      "
    >
      <div class="modal-content modal-org-single__content">
        <div class="modal-header modal-org-single__header">
          <button
            type="button"
            class="btn-close modal-org-single__cerrar"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body modal-org-single__body">
          <div class="container modal-org-single__container">
            <div class="row align-items-center modal-org-single__row">
              <div class="col-lg-12 col-md-12 col-12 modal-org-single__col">
                <iframe
                  :src="url_documento"
                  frameborder="0"
                  height="500px"
                  width="100%"
                  scrolling="no"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer modal-org-single__footer">
          <div class="container modal-org-single__container">
            <div class="row justify-content-end modal-org-single__row">
              <div class="col-12 modal-org-single__col"><hr class="modal-org-single__hr" /></div>
              <div class="col-12 modal-org-single__col text-end">
                <button
                  class="modal-org-single__btn-gris px-4"
                  data-bs-dismiss="modal"
                >
                  Cerrar
                </button>

                <a
                  :href="url_documento"
                  attributes-list
                  @click.prevent="downloadPDF(url_documento)"
                >
                  <button class="modal-org-single__btn-lila px-4" :style="{ backgroundColor: colorPrimario, borderColor: colorPrimario }">
                    Descargar
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "ModalOrganigrama",
  data() {
    return {
      //
    };
  },
  props: {
    url_documento: String,
    nombre_documento: String
  },
  methods: {
    downloadPDF(url) {

      console.log(this.nombre_documento);

      axios.get(url, {
        responseType: "blob",
      })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = this.nombre_documento;
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch(console.error);
    },
  },
};
</script>